import { put, call } from 'redux-saga/effects';
import { UsersGroupsAction, UIAction } from '../actions';
import { UsersGroupsService } from '../services';
import { generateReadableError } from 'hooks';


export function* addUserGroup(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  try {
    const { data } = yield call(UsersGroupsService.getInstance().createUserGroup, action.payload);
    yield put(UsersGroupsAction.addUserGroupSuccess(data));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
    yield put(UIAction.showMainLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}

export function* getUsersGroups(action) {
  //yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {

    const { data } = yield call(UsersGroupsService.getInstance().fetchUsersGroups, action.payload);
    if (action.payload.list){
      yield put(UsersGroupsAction.getUsersGroupsArraySuccess(data));
    }
    else{
      yield put(UsersGroupsAction.getUsersGroupsSuccess(data));
    }
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


export function* getUsersGroupsArray(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const { data } = yield call(UsersGroupsService.getInstance().fetchUsersGroupsArray, action.payload);
      yield put(UsersGroupsAction.getUsersGroupsArraySuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}



export function* assignUserGroups(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  try {
    const { data } = yield call(UsersGroupsService.getInstance().assignUserGroups, action.payload);
    yield put(UsersGroupsAction.assignUserGroupsSuccess(data));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
    yield put(UIAction.showMainLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}






